import { FC, memo } from 'react'
import { ChangeColumn, PairColumn, PriceColumn, SymbolRow } from './style'
import Iconfont from 'components/Iconfont'
import { TrendColorizerText } from 'components/TrendColorizer'
import { CombinedSymbol, isSpotSymbol } from 'utils/symbols'
import { useCurrencyByName, useTicker } from 'store/market/hooks'
import { useMarketNavigate } from 'hooks/useMarketNavigate'
import { StringFormatter } from 'utils/StringFormatter'
import { toFixed } from 'utils/number'
import { useMarketDrawer } from 'components/MarketDrawer'

export const MarketItem: FC<{
  item: CombinedSymbol
}> = memo(({ item }) => {
  const { name = '', baseCurrency = '', quoteCurrency = '' } = item
  const { close = 0, percent = 0 } = useTicker(name) ?? {}
  const { navigateToSpot, navigateToPerp } = useMarketNavigate()
  const { close: closeDrawer } = useMarketDrawer()

  const currencyInfo = useCurrencyByName(baseCurrency)

  const isSpot = isSpotSymbol(item)

  return (
    <SymbolRow
      onClick={() => {
        if (isSpotSymbol(item)) {
          navigateToSpot(baseCurrency, quoteCurrency)
        } else {
          navigateToPerp(baseCurrency, quoteCurrency)
        }
        closeDrawer()
      }}
    >
      <PairColumn>
        <img src={currencyInfo?.tokenIconUrl} alt="" />
        {isSpot ? `${baseCurrency}/${quoteCurrency}` : `${baseCurrency}-Perp`}
        <Iconfont name="icon-ArrowRight" size={12} />
      </PairColumn>
      <PriceColumn>
        <TrendColorizerText $trend={Number(percent) >= 0}>
          {close}
        </TrendColorizerText>
      </PriceColumn>
      <ChangeColumn>
        <TrendColorizerText $trend={Number(percent) >= 0}>
          {StringFormatter.numberSign(toFixed(percent, 2))}%
        </TrendColorizerText>
      </ChangeColumn>
    </SymbolRow>
  )
})
